import { render, staticRenderFns } from "./Taxonomia.vue?vue&type=template&id=78b0e374&"
import script from "./Taxonomia.vue?vue&type=script&lang=js&"
export * from "./Taxonomia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports